import {
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  Box,
  TextField,
  Dialog,
  Autocomplete,
} from '@mui/material';
import CustomInput from '../../../../../../components/shared/CustomInput';
import BackButton from '../../../../../../components/shared/BackButton';
import AddSubCategoryInCategory from './Desktop/AddSubCategoryInCategory';

import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import CustomCard from '../../../../../../components/shared/CustomCard';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import CustomButton from '../../../../../../components/shared/CustomButton';

const CategoryMenuAddMobile = (props) => {
  const {
    today,
    theme,
    AntSwitch,
    // *--- Page
    setPage,
    isSubmitAvailable,
    setIsSubmitAvailable,
    // *--- Data
    categoryAddInputDatas,
    setCategoryAddInputDatas,
    subsidiaryCategory,
    subsidiaryCategoryLoading,
    // *--- Type
    typeCategory,
    typeCategoryLoading,
    // *--- Handle
    handleBackButton,
    handleAddImage,
    handleDeleteImage,
    handleAddSub,
    handleAdd,
    // *--- Sub
    indexSubCategory,
    setIndexSubCategory,
    sub1,
    setSub1,
    sub2,
    setSub2,
    sub3,
    setSub3,
  } = props;
  return (
    <Grid container columns={12} spacing={2}>
      {/* //* Back */}
      <Grid item xs={10} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <BackButton handleClick={handleBackButton} />
        <Typography
          sx={{
            ml: '8px',
            fontSize: '16px',
            fontWeight: '600',
          }}
        >
          Add Category
        </Typography>
      </Grid>
      {/* //* Subsidiary */}
      <Grid item xs={12}>
        <Autocomplete
          sx={{ bgcolor: '#FAFAFA', borderRadius: '8px' }}
          value={categoryAddInputDatas.subsidiary}
          options={subsidiaryCategory}
          getOptionLabel={(option) => option.name}
          onChange={(event, newValue) => {
            setCategoryAddInputDatas({
              ...categoryAddInputDatas,
              subsidiaryId: parseInt(newValue.id),
              subsidiary: newValue,
            });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Subsidiary*"
              sx={{
                bgcolor: '#FAFAFA',
                borderRadius: '8px',
                width: '100%',
                '.MuiOutlinedInput-input': {
                  fontSize: '12px',
                  padding: '12px',
                },
              }}
            />
          )}
        />
      </Grid>
      {/* //* Name */}
      <Grid item xs={12}>
        <CustomInput
          sx={{
            bgcolor: '#FAFAFA',
            borderRadius: '8px',
            width: '100%',
            '.MuiOutlinedInput-input': {
              fontSize: '12px',
              padding: '12px',
            },
          }}
          placeholder="Name*"
          value={categoryAddInputDatas.name}
          onChange={(e) => {
            if (e.target.value.length <= 30) {
              setCategoryAddInputDatas({
                ...categoryAddInputDatas,
                name: e.target.value,
              });
            }
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '8px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            Enter at least 5 character
          </Typography>
          <Typography
            sx={{
              fontSize: '8px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            {categoryAddInputDatas.name.length}/30
          </Typography>
        </Box>
      </Grid>
      {/* //* Photo */}
      <Grid item xs={12} sx={{ minHeight: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            pb: `${categoryAddInputDatas.photo.length === 0 ? '16px' : '9px'}`,
          }}
        >
          <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>
            Photo
          </Typography>
          <Typography
            sx={{
              fontSize: '8px',
              fontWeight: '500',
              color: '#9E9D9D',
            }}
          >
            ( max size : 2MB )
          </Typography>
          {categoryAddInputDatas.isMaxSizePhoto && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ErrorOutlineIcon
                sx={{
                  fontSize: '8px',
                  fontWeight: '500',
                  color: theme.palette.warning.main,
                  mr: '4px',
                }}
              />
              <Typography
                sx={{
                  fontSize: '8px',
                  fontWeight: '500',
                  color: theme.palette.warning.main,
                }}
              >
                The photo can't be more than 2MB
              </Typography>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {categoryAddInputDatas.photo.length === 0 && (
              <Box
                sx={{
                  height: '54px',
                  width: '54px',
                  aspectRatio: '1/1',
                  borderRadius: '8px',
                  bgcolor: '#F5F5F5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderStyle: 'dashed',
                  borderColor: '#9E9D9D',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  document.getElementById('input_img').click();
                }}
              >
                <ImageOutlinedIcon
                  sx={{ color: '#9E9D9D', fontSize: '28px' }}
                />
              </Box>
            )}
            {categoryAddInputDatas.photo.map((input, index) => (
              <Box
                sx={{
                  position: 'relative',
                  overflow: 'visible',
                  padding: '7px',
                }}
                key={index}
              >
                <CancelIcon
                  sx={{
                    position: 'absolute',
                    fontSize: '20px',
                    top: 1,
                    right: 1,
                    zIndex: +1,
                    cursor: 'pointer',
                  }}
                  onClick={() => handleDeleteImage(input, index)}
                />
                <Box
                  component="img"
                  src={URL.createObjectURL(input)}
                  sx={{
                    height: '54px',
                    width: '54px',
                    aspectRatio: '1/1',
                    borderRadius: '8px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setCategoryAddInputDatas({
                      ...categoryAddInputDatas,
                      indexPreviePhoto: index + 1,
                      isPreviewPhoto: 'true',
                    });
                  }}
                />
              </Box>
            ))}
          </Box>

          <Box
            sx={{
              display: 'flex',
              mb: '7px',
              ml: '20px',
              alignItems: 'center',
            }}
          >
            {categoryAddInputDatas.photo.length < 3 && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  color: theme.palette.primary.main,
                  cursor: 'pointer',
                }}
                onClick={() => {
                  document.getElementById('input_img').click();
                }}
              >
                <input
                  accept="image/*"
                  id="input_img"
                  type="file"
                  style={{ display: 'none' }}
                  onChange={handleAddImage}
                />
                <AddIcon sx={{ fontSize: '16px' }} />
                <Typography sx={{ fontSize: '12px', fontWeight: '600' }}>
                  Add More
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Grid>
      {/* //* Dialog Photo */}
      {categoryAddInputDatas.indexPreviePhoto !== 0 && (
        <Dialog
          open={categoryAddInputDatas.isPreviewPhoto}
          onClose={() => {
            setCategoryAddInputDatas({
              ...categoryAddInputDatas,
              isPreviewPhoto: !categoryAddInputDatas.isPreviewPhoto,
            });
          }}
        >
          <Box
            component="img"
            src={URL.createObjectURL(
              categoryAddInputDatas.photo[
                categoryAddInputDatas.indexPreviePhoto - 1
              ]
            )}
            sx={{ width: '100%', aspectRation: '1/1' }}
          />
        </Dialog>
      )}
      {/* //* Description */}
      <Grid item xs={12}>
        <CustomInput
          sx={{
            width: '100%',
            bgcolor: '#FAFAFA',
            '.MuiOutlinedInput-input': {
              fontSize: '12px',
              padding: '12px',
            },
          }}
          placeholder="Description"
          value={categoryAddInputDatas.description}
          onChange={(e) => {
            if (e.target.value.length <= 250) {
              setCategoryAddInputDatas({
                ...categoryAddInputDatas,
                description: e.target.value,
              });
            }
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '8px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            Enter at least 20 character
          </Typography>
          <Typography
            sx={{
              fontSize: '8px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            {categoryAddInputDatas.description.length}/250
          </Typography>
        </Box>
      </Grid>
      {/* //* Schedule */}
      <Grid item xs={12} sx={{}}>
        <Box sx={{ display: 'flex', minWidth: '100%' }}>
          <DesktopDatePicker
            inputFormat="DD/MM/YYYY"
            value={categoryAddInputDatas.schedule}
            onChange={(newValue) => {
              if (categoryAddInputDatas.scheduleType !== 'now') {
                setCategoryAddInputDatas({
                  ...categoryAddInputDatas,
                  schedule: newValue,
                });
              } else {
                setCategoryAddInputDatas({
                  ...categoryAddInputDatas,
                  schedule: today,
                });
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{
                  width: '100%',
                  bgcolor: '#FAFAFA',
                  '.MuiOutlinedInput-input': {
                    fontSize: '12px',
                    padding: '12px',
                  },
                }}
              />
            )}
          />
        </Box>
      </Grid>
      {/* //* STATUS */}
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>
          Publish
        </Typography>
        <AntSwitch
          checked={categoryAddInputDatas.publish}
          onChange={(e) => {
            setCategoryAddInputDatas({
              ...categoryAddInputDatas,
              publish: !categoryAddInputDatas.publish,
            });
          }}
        />
      </Grid>
      {/* //* SUBMIT */}
      <Grid item xs={12} sx={{ mt: '28px' }}>
        <CustomButton
          // disabled={!isSubmitAvailable}
          onClick={handleAdd}
          variant="contained"
          sx={{
            width: '100%',
          }}
        >
          Submit
        </CustomButton>
      </Grid>
    </Grid>
  );
};

export default CategoryMenuAddMobile;
